export const environment = {
  development: true,
  production: false,
  host: 'https://dev.slickpayroll.com/',
  hmr: false,
  backend: false,
  host_api_url: 'https://dev.slickpayroll.com/'
};
